import React, { useEffect, useState } from "react"
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap"
import RolesModule from "./RolesModule"
import { Switch } from "antd"
import { FetchPostData, FetchPutData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/Loader"

const RolesModal = ({
  open,
  toggle,
  selectedRole,
  setselectedRole,
  viewOnly,
  getRoles,
}) => {
  const [Permissions, setPermissions] = useState([])
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (selectedRole?.id) {
      const permission = selectedRole?.permissions
        ? JSON.parse(selectedRole?.permissions)
        : []


      const permissions = RolesModule.map((per, index) => {
        const perm = permission[index]

        return {
          ...per,
          view: Number(perm?.view || 0),
          add: Number(perm?.add || 0),
          edit: Number(perm?.edit || 0),
          delete: Number(perm?.delete || 0),
        }
      })

      setPermissions(permissions)
    } else {
      setPermissions(RolesModule)
    }
  }, [selectedRole])

  const handleToggle = (moduleId, field) => {
    const updated = Permissions.map(item => {
      if (item.id === moduleId) {
        return { ...item, [field]: item[field] === 1 ? 0 : 1 }
      }
      return item
    })
    setPermissions(updated)
  }

  const onSubmit = async () => {
    if (!selectedRole?.roleName) {
      setError("Role Name is Required")
      return
    }
    if (selectedRole?.id) {
      const APIdata = await FetchPutData(setLoading, "roles", selectedRole?.id ,{
        roleName: selectedRole?.roleName,
        permissions: JSON.stringify(Permissions),
      })
      if (APIdata?.data?.success) {
        Swal.fire({
          title: "Role Added Successfully.",
          text: APIdata?.data?.message,
          icon: "success",
        })
        getRoles()
        toggle()
      } else {
        Swal.fire({
          title: "Error Adding Roles.",
          text: APIdata?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(setLoading, "roles", {
        roleName: selectedRole?.roleName,
        permissions: JSON.stringify(Permissions),
      })
      if (APIdata?.data?.success) {
        Swal.fire({
          title: "Role Added Successfully.",
          text: APIdata?.data?.message,
          icon: "success",
        })
        getRoles()
        toggle()
      } else {
        Swal.fire({
          title: "Error Adding Roles.",
          text: APIdata?.data?.message,
          icon: "error",
        })
      }
    }
  }

  return (
    <Modal isOpen={open} centered size="xl">
      {loading && <Loader />}
      <ModalHeader toggle={toggle}>
        {viewOnly ? "View Role" : selectedRole?.id ? "Edit Role" : "Add Role"}
      </ModalHeader>
      <ModalBody>
        <Label>
          Role Name <span className="text-danger">*</span>
        </Label>
        <Input
          className="form-control rounded-4"
          placeholder="Enter Role Name"
          value={selectedRole?.roleName || ""}
          onChange={e =>
            setselectedRole(prev => ({ ...prev, roleName: e.target.value }))
          }
        />
        {error && <span className="text-danger">{error}</span>}

        <Table
          className="table border-dark m-0 text-center mt-4 role-table"
          striped
          bordered
        >
          <thead className="table-dark">
            <tr>
              <th className="text-start">Module</th>
              <th>View</th>
              <th>Add</th>
              <th>Update</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {Permissions?.length > 0 &&
              Permissions.map(item => (
                <tr key={item.id} className="py-2">
                  <td
                    className={`text-start ${
                      !item.parentId ? "fw-bold" : "ps-5"
                    }`}
                  >
                    {item.module}
                  </td>

                  {/* View Switch */}
                  <td>
                    <Switch
                      checked={item.view === 1}
                      onChange={() => handleToggle(item.id, "view")}
                      disabled={viewOnly}
                    />
                  </td>

                  {/* Add Switch */}
                  <td>
                    {item.isAdd ? (
                      <Switch
                        checked={item.add === 1}
                        onChange={() => handleToggle(item.id, "add")}
                        disabled={viewOnly}
                      />
                    ) : (
                      "--"
                    )}
                  </td>

                  {/* Edit Switch */}
                  <td>
                    {item.isEdit ? (
                      <Switch
                        checked={item.edit === 1}
                        onChange={() => handleToggle(item.id, "edit")}
                        disabled={viewOnly}
                      />
                    ) : (
                      "--"
                    )}
                  </td>

                  {/* Delete Switch */}
                  <td>
                    {item.isDelete ? (
                      <Switch
                        checked={item.delete === 1}
                        onChange={() => handleToggle(item.id, "delete")}
                        disabled={viewOnly}
                      />
                    ) : (
                      "--"
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </ModalBody>
      {!viewOnly && (
        <ModalFooter>
          <Button className="bg-blue" onClick={onSubmit}>
            Submit
          </Button>
          <Button className="btn-secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      )}
    </Modal>
  )
}

export default RolesModal
